function Navbar({ children }) {
  return (
    <nav className="navbar shadow-sm">
      <div className="navbar-container my-3">
        {children}
      </div>
    </nav>
  );
}

export default Navbar;
